import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
      requireAuth: false,
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/pages/Home.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/press-release',
    name: 'pressRelease',
    component: () => import('@/views/pages/PressRelease.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/press-release-detail',
    name: 'newPressRelease',
    component: () => import('@/views/pages/PressReleaseDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/press-release-detail/:id',
    name: 'editPressRelease',
    component: () => import('@/views/pages/PressReleaseDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/media-coverage',
    name: 'MediaCoverage',
    component: () => import('@/views/pages/MediaCoverage.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/media-coverage-detail',
    name: 'newMediaCoverage',
    component: () => import('@/views/pages/MediaCoverageDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/media-coverage-detail/:id',
    name: 'editMediaCoverage',
    component: () => import('@/views/pages/MediaCoverageDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/views/pages/Jobs.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/job-detail',
    name: 'newJob',
    component: () => import('@/views/pages/JobDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/job-detail/:id',
    name: 'editJob',
    component: () => import('@/views/pages/JobDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: () => import('@/views/pages/announcements.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/announcement-detail',
    name: 'newAnnouncement',
    component: () => import('@/views/pages/announcementDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/announcement-detail/:id',
    name: 'editAnnouncement',
    component: () => import('@/views/pages/announcementDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/pages/reports.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/report-detail',
    name: 'newReport',
    component: () => import('@/views/pages/reportDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/report-detail/:id',
    name: 'editReport',
    component: () => import('@/views/pages/reportDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/presentation',
    name: 'Presentation',
    component: () => import('@/views/pages/Presentation.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/presentation-detail',
    name: 'newPresentation',
    component: () => import('@/views/pages/PresentationDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/presentation-detail/:id',
    name: 'editPresentation',
    component: () => import('@/views/pages/PresentationDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/analyst-coverage',
    name: 'AnalystCoverage',
    component: () => import('@/views/pages/AnalystCoverage.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/analyst-coverage-detail',
    name: 'newAnalystCoverage',
    component: () => import('@/views/pages/AnalystCoverageDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/analyst-coverage-detail/:id',
    name: 'editAnalystCoverage',
    component: () => import('@/views/pages/AnalystCoverageDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/investor-relations-notices',
    name: 'InvestorRelationsNotices',
    component: () => import('@/views/pages/InvestorRelationsNotices.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/investor-relations-notices-detail',
    name: 'newInvestorNotices',
    component: () => import('@/views/pages/InvestorRelationsNoticesDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/investor-relations-notices-detail/:id',
    name: 'editInvestorNotices',
    component: () => import('@/views/pages/InvestorRelationsNoticesDetail.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/enquiry',
    name: 'Enquiry',
    component: () => import('@/views/pages/Enquiry.vue'),
    meta: {
      requireAuth: true,
    },
  },

  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   component: () => import('@/views/dashboard/Dashboard.vue'),
  // },
  // {
  //   path: '/typography',
  //   name: 'typography',
  //   component: () => import('@/views/typography/Typography.vue'),
  // },
  // {
  //   path: '/icons',
  //   name: 'icons',
  //   component: () => import('@/views/icons/Icons.vue'),
  // },
  // {
  //   path: '/cards',
  //   name: 'cards',
  //   component: () => import('@/views/cards/Card.vue'),
  // },
  // {
  //   path: '/simple-table',
  //   name: 'simple-table',
  //   component: () => import('@/views/simple-table/SimpleTable.vue'),
  // },
  // {
  //   path: '/form-layouts',
  //   name: 'form-layouts',
  //   component: () => import('@/views/form-layouts/FormLayouts.vue'),
  // },
  // {
  //   path: '/pages/account-settings',
  //   name: 'pages-account-settings',
  //   component: () => import('@/views/pages/account-settings/AccountSettings.vue'),
  // },
  // {
  //   path: '/pages/login',
  //   name: 'pages-login',
  //   component: () => import('@/views/pages/Login.vue'),
  //   meta: {
  //     layout: 'blank',
  //   },
  // },
  // {
  //   path: '/pages/register',
  //   name: 'pages-register',
  //   component: () => import('@/views/pages/Register.vue'),
  //   meta: {
  //     layout: 'blank',
  //   },
  // },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (
      router.app.$store.state.api.login_status &&
      router.app.$store.state.api.login_data != '' &&
      router.app.$store.state.api.login_data != null
    ) {
      next() // 往下執行
    } else {
      //如果使用者token無效則跳轉到login頁面
      if (to.path !== '/login') {
        next('/login')
      } else {
        next() // 往下執行
      }
    }
  } else if (
    !to.meta.requireAuth &&
    router.app.$store.state.api.login_status &&
    router.app.$store.state.api.login_data != '' &&
    router.app.$store.state.api.login_data != null
  ) {
    next('/home')
  } else {
    next() // 往下執行
  }
})

export default router
